import { useSearchParams } from 'react-router-dom'

const useSearchParam = (param: string): string | null => {
  const [searchParams] = useSearchParams()

  return searchParams.get(param)
}

export default useSearchParam
